<div class="row">
  <div class="icons text-primary col-sm-12 " style="text-align:center;font-size:48px;">
    <span class="icon-loading"></span>
  </div>

</div>
<div class="mb-4 row">
  <div class="col-2 "></div>
  <div class="col-8 ">
    <h5><b style="color:black !important">{{  'WorkflowCreatePM.PreStage.SubmitPreStage.SubmitMessageOne' | translate}}</b></h5>
    <p>{{  'WorkflowCreatePM.PreStage.SubmitPreStage.SubmitMessageTwo' | translate}}</p>
    <h5><b style="color:black !important">{{  'WorkflowCreatePM.PreStage.SubmitPreStage.SubmitMessageThree' | translate}}</b></h5>
    
  </div>
</div>
